import React, { Component } from 'react';
import { FlashState, withAuthentication, withRouter} from "cw-styleguide-react";
import { Navigate } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import {COURSE_TITLE_FIELD_COURSE, COURSE_TITLE_FIELD_QUALIFICATION, LANGUAGE_CY, LANGUAGE_EN, OPERATION_CREATE, OPERATION_DUPLICATE, OPERATION_EDIT, ROLE_STAFF} from "../../../constants";
import CoursesCreateView from "../views/CoursesCreateView";
import CoursesEditView from "../views/CoursesEditView";
import NavigateWithSearch from "../../../components/NavigateWithSearch";


class CoursesCreateEditController extends Component {

  constructor(props) {
    super(props);

    this.state = {
      titleField: this.props.authentication.hasRole(ROLE_STAFF) ? COURSE_TITLE_FIELD_COURSE : COURSE_TITLE_FIELD_QUALIFICATION
    };

    this.handleSetTitleField = this.handleSetTitleField.bind(this);
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.init();
  }


  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.operation !== prevProps.operation) {
      this.init();
    }
  }

  init() {

    // If we are editing a venue then load it into the state.
    if (this.props.operation === OPERATION_EDIT) {
      this.props.loadCourse(this.props.params.course);
      this.props.loadAudit(this.props.params.course);
    }   else if (this.props.operation === OPERATION_DUPLICATE) {
      this.props.loadCourse(this.props.params.course, true);
      this.props.clearAudit();
    } else {
      this.props.clearCourse();
    }
    this.props.clearMessages();
  }

  handleSetTitleField(e, field) {
    // e.preventDefault();

    this.setState({
      titleField: field
    });
  }

  /**
   * Perform a customised action if someone clicks on an error in the summary. Used to change the language to welsh.
   * @param event
   * @param field
   */
  handleErrorClick(event, field) {
    // We dont prevent the event default as we still want to go to the clicked route.
    this.setState({
      language: field.includes('_cy') ? LANGUAGE_CY : LANGUAGE_EN
    })
  }

  render() {
    if (this.props.redirect) {
      FlashState.set('flashMessages', this.props.messages);
      return <NavigateWithSearch path={this.props.redirect } />
    }

    if (this.props.operation === OPERATION_CREATE || this.props.operation === OPERATION_DUPLICATE) {
      return (
        <CoursesCreateView
          {...this.props}
          {...this.state}
          handleSetTitleField={this.handleSetTitleField} />
      );
    }

    if (this.props.operation === OPERATION_EDIT) {
      return (
        <CoursesEditView
          {...this.props}
          {...this.state}
          handleSetTitleField={this.handleSetTitleField} />
      );
    }

    return null;
  }

}

export default withRouter(withAuthentication(withTranslation('local')(CoursesCreateEditController)));
